var _path, _path2, _rect, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSanaDe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "#0069b4",
    viewBox: "0 0 340.158 524.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.772,212.598H0c0,62.621,50.764,113.386,113.386,113.386h226.772             C340.158,263.363,289.393,212.598,226.772,212.598z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.992,41.284v29.582h14.173V41.284c8.252-2.922,14.173-10.771,14.173-20.024             c0-11.741-9.518-21.26-21.26-21.26c-11.741,0-21.26,9.518-21.26,21.26C148.819,30.513,154.74,38.362,162.992,41.284z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 162.992,
    y: 467.716,
    width: 14.173,
    height: 56.693
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.386,340.158C50.764,340.158,0,390.922,0,453.543h226.772             c62.621,0,113.386-50.765,113.386-113.386H113.386z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.386,85.039C50.764,85.039,0,135.804,0,198.425h226.772c62.621,0,113.386-50.765,113.386-113.386             H113.386z M258.201,141.48c-9.393,0-17.008-7.615-17.008-17.008c0-9.393,7.615-17.008,17.008-17.008             c9.393,0,17.008,7.615,17.008,17.008C275.209,133.866,267.594,141.48,258.201,141.48z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanaDe);
export default __webpack_public_path__ + "static/media/sana-de.af34a4430094619585d0e13d165bb9c2.svg";
export { ForwardRef as ReactComponent };